export enum EDeviceType {
    WINDOWS = 'WINDOWS',
    MACOS = 'MACOSX',
    IOS = 'IOS',
    ANDROID = 'ANDROID'
}